(function () {
  'use strict';
  if (window.rxCartCookieGuard) return;

  var VERSION = '1.0.0';
  var COOKIE_SCRIPT_SOURCE = /https:\/\/cdn\.cookie-script\.com\/s\/75160db4f5dcff1ffb7baed6ea9fdfde\.js/i;
  var deletion = /(?:^|;)\s*(?:expires\s*=\s*([^;]+)|max-age\s*=\s*(-?\d+))/ig;
  var blocked = 0;

  function isExpiredAssignment(value) {
    var text = String(value || '');
    var first = text.split(';', 1)[0];
    var separator = first.indexOf('=');
    if (separator < 0 || first.slice(0, separator).trim() !== 'cart') return false;
    if (first.slice(separator + 1) !== '') return false;

    deletion.lastIndex = 0;
    var match;
    while ((match = deletion.exec(text))) {
      if (match[2] !== undefined && Number(match[2]) <= 0) return true;
      if (match[1]) {
        var expires = Date.parse(match[1]);
        if (!isNaN(expires) && expires <= Date.now()) return true;
      }
    }
    return false;
  }

  try {
    var descriptor = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie');
    if (!descriptor || !descriptor.configurable || !descriptor.get || !descriptor.set) throw new Error('cookie descriptor unavailable');

    Object.defineProperty(Document.prototype, 'cookie', {
      configurable: descriptor.configurable,
      enumerable: descriptor.enumerable,
      get: descriptor.get,
      set: function (value) {
        if (isExpiredAssignment(value)) {
          var stack = String(new Error().stack || '');
          if (COOKIE_SCRIPT_SOURCE.test(stack)) {
            blocked += 1;
            try {
              window.dispatchEvent(new CustomEvent('rx:cart-cookie-protected', {
                detail: { source: 'CookieScript', count: blocked }
              }));
            } catch (error) {}
            return value;
          }
        }
        return descriptor.set.call(this, value);
      }
    });

    window.rxCartCookieGuard = {
      version: VERSION,
      temporary: true,
      blockedCount: function () { return blocked; }
    };
  } catch (error) {
    window.rxCartCookieGuard = {
      version: VERSION,
      temporary: true,
      unavailable: true,
      blockedCount: function () { return blocked; }
    };
  }
})();
